import { ENVIRONMENTS } from './constants.js';

/**
 * @returns {string} The environment name
 */
export function getEnvironment() {
	if (typeof window === 'undefined') {
		console.log('__NODE_ENV__', __NODE_ENV__); // eslint-disable-line no-undef
		switch (
			__NODE_ENV__ // eslint-disable-line no-undef
		) {
			case 'review':
				return ENVIRONMENTS.DEVELOPMENT;
			case 'development':
				return ENVIRONMENTS.DEVELOPMENT;
			default:
				return ENVIRONMENTS.PRODUCTION;
		}
	}

	const hostname = window.location.hostname;

	if (hostname.includes('review') || hostname.includes('web.dev')) {
		return ENVIRONMENTS.DEVELOPMENT;
	}

	if (hostname.includes('localhost') || hostname.includes('local.dev')) {
		return ENVIRONMENTS.LOCAL_DEVELOPMENT;
	}

	if (hostname.includes('stage')) {
		return ENVIRONMENTS.STAGING;
	}

	return ENVIRONMENTS.PRODUCTION;
}

/**
 * Returns an environment-specific value based on the current environment.
 * Generic helper that works with any value type (strings, objects, functions, etc.).
 * If the value is not set for a specific environment, a fallback value is used.
 * @template T
 * @param {object} values - Environment-specific values
 * @param {T} [values.local] - Value for LOCAL_DEVELOPMENT environment
 * @param {T} [values.dev] - Value for DEVELOPMENT environment
 * @param {T} [values.staging] - Value for STAGING environment
 * @param {T} values.production - Value for PRODUCTION environment (required, used as fallback)
 * @returns {T} The value corresponding to the current environment
 */
export function returnValueByEnv({ local, dev, staging, production }) {
	const env = getEnvironment();
	console.log('env', env);
	switch (env) {
		case ENVIRONMENTS.LOCAL_DEVELOPMENT:
			return local ?? dev ?? production;
		case ENVIRONMENTS.DEVELOPMENT:
			return dev ?? production;
		case ENVIRONMENTS.STAGING:
			return staging ?? production;
		default:
			return production;
	}
}
